import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "rec-textarea" };
const _hoisted_2 = {
    key: 0,
    class: "rec-form-label"
};
const _hoisted_3 = ["textContent"];
const _hoisted_4 = ["textContent"];
const _hoisted_5 = ["cols", "rows"];
import { useVModel } from "@vueuse/core";
import { onUnmounted, ref, watch } from "vue";
// Components
import RTEditor from "@/common/components/RedactorTextEditor.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecTextarea',
    props: {
        modelValue: {},
        label: { default: "" },
        required: { type: Boolean },
        errors: { default: () => [] },
        isFocused: { type: Boolean },
        density: { default: "default" },
        richTextEditor: { type: Boolean },
        rows: { default: 4 },
        cols: { default: 30 }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const redactor_base = props.richTextEditor ? [window.redactor_base] : [];
        const inputEl = ref();
        const rteInput = ref();
        const model = useVModel(props, "modelValue", emit); // TODO: use defineModel instead
        if (props.richTextEditor) {
            watch(rteInput, (editor) => {
                if (!editor)
                    return;
                inputEl.value = editor.getEditor()[0];
            }, { immediate: true });
        }
        onUnmounted(() => {
            if (!props.richTextEditor || !inputEl.value?.flush)
                return;
            inputEl.value.flush();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                (_ctx.label)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                        _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.label)
                        }, null, 8, _hoisted_3),
                        _createElementVNode("span", {
                            class: "text-danger",
                            textContent: _toDisplayString(_ctx.required ? ' *' : '')
                        }, null, 8, _hoisted_4)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.richTextEditor)
                    ? (_openBlock(), _createBlock(RTEditor, {
                        key: 1,
                        id: "rich-text-editor",
                        ref_key: "rteInput",
                        ref: rteInput,
                        modelValue: _unref(model),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                        class: "text-wrap",
                        configs: _unref(redactor_base),
                        cols: _ctx.cols,
                        rows: _ctx.rows,
                        "editor-classes": `rc-font16`
                    }, null, 8, ["modelValue", "configs", "cols", "rows"]))
                    : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 2,
                        ref_key: "inputEl",
                        ref: inputEl,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                        cols: _ctx.cols,
                        rows: _ctx.rows,
                        class: "rec-form-control rec-form-control--textarea"
                    }, null, 8, _hoisted_5)), [
                        [_vModelText, _unref(model)]
                    ])
            ]));
        };
    }
});
